import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { ShieldCheck, Mail, Lock, LogIn } from 'lucide-react';

export default function AdminLogin() {
  const { admin, login } = useAdminAuth();
  const [f, setF] = useState({ email: '', password: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setLoading(true);
    try { await login(f.email, f.password); nav('/admin'); }
    catch (e2) { setErr(e2?.response?.data?.detail || 'Giriş başarısız'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#08080b] text-white p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-16 h-16 rounded-2xl bg-gradient-to-br from-[#f0c766] to-[#a97a1f] items-center justify-center mb-4"><ShieldCheck className="w-8 h-8 text-[#17140b]" /></div>
          <h1 className="font-display text-3xl font-black">AEGIS <span className="gold-text">ADMIN</span></h1>
          <p className="text-white/50 text-sm mt-1">Yönetim paneline giriş yapın.</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#111015] to-[#0a090c] p-8 space-y-5">
          <label className="block"><span className="text-xs tracking-widest text-white/50">E-POSTA</span>
            <div className="relative mt-2"><Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
              <input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
          <label className="block"><span className="text-xs tracking-widest text-white/50">PAROLA</span>
            <div className="relative mt-2"><Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
              <input required type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
          {err && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-2">{err}</div>}
          <button disabled={loading} className="w-full btn-gold h-12 rounded-lg inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest disabled:opacity-60">
            {loading ? 'GİRİŞ YAPILIYOR...' : <><LogIn className="w-4 h-4" /> GİRİŞ YAP</>}
          </button>
        </form>
      </div>
    </div>
  );
}
